import { SPECIES_ORDER, type SpeciesId } from '@cuboom/shared';

/** How many soldiers each team fields — and how many the menu lets you pick. */
export const SQUAD_SIZE = 3;

const KEY = 'cuboom.squad';

/** The player's saved squad (first three of the roster when unset). */
export function loadSquad(): SpeciesId[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const arr = JSON.parse(raw) as unknown;
      if (Array.isArray(arr)) {
        const valid = arr.filter((s): s is SpeciesId =>
          typeof s === 'string' && (SPECIES_ORDER as string[]).includes(s),
        );
        if (valid.length >= SQUAD_SIZE) return valid.slice(0, SQUAD_SIZE);
      }
    }
  } catch {
    // Private mode / bad JSON — fall through to the default squad.
  }
  return SPECIES_ORDER.slice(0, SQUAD_SIZE);
}

export function saveSquad(squad: SpeciesId[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(squad.slice(0, SQUAD_SIZE)));
  } catch {
    // Private mode — the pick just won't survive a reload.
  }
}

/**
 * CPU squad: the first three species the player did NOT take, so a mirror
 * match never spawns identical faces on both sides. Deterministic on purpose.
 */
export function cpuSquad(player: SpeciesId[]): SpeciesId[] {
  const out: SpeciesId[] = [];
  for (const s of SPECIES_ORDER) {
    if (!player.includes(s)) out.push(s);
    if (out.length === SQUAD_SIZE) break;
  }
  let i = 0;
  while (out.length < SQUAD_SIZE) {
    const s = SPECIES_ORDER[i++ % SPECIES_ORDER.length];
    if (!out.includes(s)) out.push(s);
  }
  return out;
}
